import React from 'react'
import {
  maricopaCountyLogoWhiteSrc,
} from '../svg'
import maricopaHeaderLogoSrc from '../svg/maricopa-header-logo.svg'

interface EpcLogoProps {
  size?: string
  inverted?: boolean
}

const mapSizeClass = (size?: string) => {
  switch (size) {
    case 'xs':
      return 'text-xs'
    case 'sm':
      return 'text-sm'
    case 'md':
      return 'text-base'
    case 'lg':
      return 'text-lg'
    default:
      return size?.startsWith('text-') ? size : 'text-2xl'
  }
}

const makeHeaderStyle = ({ size, inverted }: EpcLogoProps) =>
  `font-heading font-extrabold tracking-tight leading-none ${mapSizeClass(
    size
  )} ${inverted ? 'text-white' : 'text-secondary'} uppercase`

export const EpcLogo: React.FC<EpcLogoProps> = ({
  size,
  inverted,
}) => (
  <div className="flex items-center min-w-0 gap-4">
    <img
      src={inverted ? maricopaCountyLogoWhiteSrc : maricopaHeaderLogoSrc}
      alt="Maricopa County"
      className="h-12 w-auto flex-shrink-0"
    />
    <h1 className={`truncate ${makeHeaderStyle({ size, inverted })}`}>
      Educator Pro Connect
    </h1>
  </div>
)

export const EpcLogoXL: React.FC = () => (
  <div className="flex font-body bg-primary p-2">
    <img
      src={maricopaCountyLogoWhiteSrc}
      alt="Maricopa County"
      style={{ width: '8rem' }}
      className="h-auto my-auto mr-2"
    />
    <h1 className="flex flex-col p-0 m-0 font-extrabold leading-none text-lg">
      <p className="text-white">Educator</p>
      <p>
        <span className="text-accent">PRO</span>{' '}
        <span className="text-white">Connect</span>
      </p>
    </h1>
  </div>
)

export const EpcAdminLogo: React.FC = () => (
  <div className="flex">
    <h1
      className={`flex flex-col my-auto mr-2 p-0 leading-tight ${makeHeaderStyle(
        {
          size: 'xs',
          inverted: false,
        }
      )}`}
    >
      <small className="flex ml-auto">Educator</small>
      <small className="flex ml-auto">
        <span className="text-accent mr-1">PRO</span> <span>Connect</span>
      </small>
    </h1>
    <h2 className={makeHeaderStyle({ size: 'text-lg', inverted: false })}>
      <span className="text-secondary">Admin</span>
    </h2>
  </div>
)
